import { Component, OnInit } from '@angular/core';
import { ComponentSettings } from "../../models/componentSettings";
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FirebaseObjectObservable } from "angularfire2/database-deprecated";
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { isNullOrUndefined, isUndefined } from "util";
import { FeatureItem } from "../../models/feature-item";
import { About } from '../../models/about';
import { environment } from '../../../environments/environment';
import { svgIconOptions } from '../../models/svgIconOptions';
import { svgLinedIconOptions } from '../../models/svgLinedIconOptions';
import { AboutRow } from '../../models/aboutRow';
import { PageSettings } from '../../models/pageSettings';
import { svgColorLinedIconOptions } from '../../models/svgColoredLinedIconOptions';

@Component({
  selector: 'app-location-component-data-settings',
  templateUrl: './location-component-data-settings.component.html',
  styleUrls: ['./location-component-data-settings.component.scss']
})
export class LocationComponentDataSettingsComponent implements OnInit {

  smallPrimaryIconBar: {
    title: string,
    title1: string,
    title2: string,
    title3: string,
    icon1url: string,
    icon2url: string,
    icon3url: string,
    card1url: string;
    card2url: string;
    card3url: string;
    text1: string,
    text2: string,
    text3: string,
    backText1: string,
    backText2: string,
    backText3: string,
    alt1: string,
    alt2: string,
    alt3: string,
    seoTitle1: string,
    seoTitle2: string,
    seoTitle3: string
  };
  features: Array<FeatureItem>;
  componentSettings: ComponentSettings;
  pageSettings: PageSettings;

  feature: FeatureItem;
  selectedFeature: FeatureItem;
  newFeature: boolean;
  displayFeatureDialog: boolean;

  key: string;
  locKey: string;
  // location: FirebaseObjectObservable<LocationInfo>;
  locationData: LocationInfo;
  clientData: Client;

  options = {
    key: environment.froalaKey,
    placeholderText: 'Edit Your Content Here! Don\'t leave this blank or else nothing will show up on your website.',
    charCounterCount: true,
    htmlRemoveTags: [],
    htmlExecuteScripts: false,
    htmlAllowedEmptyTags: ['div', 'textarea', 'a', 'iframe', 'object', 'video', 'style', 'script', '.fa', '.mdi'],
    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', '|', 'insertImage', 'strikeThrough', 'outdent', 'indent', 'clearFormatting', 'insertLink', 'emoticons', 'html'],
    toolbarButtonsXS: ['undo', 'redo', '-', 'bold', 'italic', 'underline'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style']
  };

  aboutRowsLayoutOptions = [
    { label: 'Image Left', value: 'imageLeft' },
    { label: 'Image Right', value: 'imageRight' },
    { label: 'Stacked Image Top', value: 'stackedImageTop' },
    { label: 'Stacked Image Bottom', value: 'stackedImageBottom' },
    { label: 'Image Only', value: 'imageOnly' },
    { label: 'HTML Only', value: 'htmlOnly' },
  ];

  iconOptions;

  constructor(
    public afService: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  resetBar() {
    this.smallPrimaryIconBar = {
      title: '',
      title1: '',
      title2: '',
      title3: '',
      icon1url: '',
      icon2url: '',
      icon3url: '',
      card1url: '',
      card2url: '',
      card3url: '',
      text1: '',
      text2: '',
      text3: '',
      backText1: '',
      backText2: '',
      backText3: '',
      alt1: '',
      alt2: '',
      alt3: '',
      seoTitle1: '',
      seoTitle2: '',
      seoTitle3: '',
    };
  }

  saveBar() {
    this.afService.saveLocationSmallPrimaryIconBar(this.key, this.locKey, this.smallPrimaryIconBar).then(() => {
      this.afService.openSnackBar('Small Primary Bar Updated successfully.')
    })
  }

  saveSummary(which) {
    if (which === 'rent') {
      this.afService.saveLocationSummary(this.key, this.locKey, this.locationData.rentSummary, which).then(() => {
        this.afService.openSnackBar('Summary Updated successfully.')
      });
    }
    else if (which === 'reserve') {
      this.afService.saveLocationSummary(this.key, this.locKey, this.locationData.reserveSummary, which).then(() => {
        this.afService.openSnackBar('Summary Updated successfully.')
      });
    }
  }

  saveFeatures() {
    for (let tmp of this.features) {
      delete tmp._$visited;
    }
    this.afService.saveLocationFeaturesIconBar(this.key, this.locKey, this.features).then(() => {
      this.afService.openSnackBar('Features Updated successfully.')
    })
  }

  resetFeatures() {
    this.features = [
      { name: 'Climate Controlled', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/4944%20-%20Snowfall.svg?alt=media&token=190e8eb4-c817-4f5f-bb6b-812dae107e19', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Gated Access', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/2030%20-%20Locker%20Room.svg?alt=media&token=2c03eb94-b913-447f-a299-0d8ab1103d82', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: '24/7 Video Recording', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/2701%20-%20Camera.svg?alt=media&token=fb1b82b8-0ab4-4b94-8706-2b731e74c0c2', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Well-lit Premises', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/4745%20-%20Bulb.svg?alt=media&token=d73f6f1a-5503-45a3-80cc-5d0ad5fac33b', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Moving Supplies', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/5103%20-%20Package%20I.svg?alt=media&token=21444d05-2db2-4f8c-81ac-ca3ea00d380a', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Easy Bill Pay', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/6200%20-%20Online%20Money.svg?alt=media&token=decfc391-75b5-42fd-92cc-0ea8de07d967', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' }
    ];
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.locKey = params['locKey'];

      this.afService.loadLocationSmallPrimaryIconBar(this.key, this.locKey).subscribe((data) => {
        if (isUndefined(data.$value)) {
          this.smallPrimaryIconBar = data;
        }
        else {
          this.resetBar();
        }
      });
      this.afService.loadLocationFeaturesIconBar(this.key, this.locKey).subscribe((data) => {
        if (isUndefined(data.$value)) {
          this.features = data;
        }
      });
      this.afService.getLocationInfo(this.key, this.locKey).subscribe((locationData) => {
        this.locationData = locationData;
        if (isNullOrUndefined(this.locationData.about)) {
          this.locationData.about = new About();
        }
        if (isNullOrUndefined(this.locationData.insightsHero)) {
          this.locationData.insightsHero = {
            title: this.locationData.name,
            subtitle: 'Storage Units in ' + this.locationData.address2
          }
        }
        if (isNullOrUndefined(this.locationData.pictureCard)) {
          this.locationData.pictureCard = { title: '', buttonText: '', buttonUrl: '', cardItem: [] }
        }
      });
      this.afService.loadComponentSettings(this.key).subscribe((data) => {
        if (isUndefined(data.$value)) {
          this.componentSettings = data;
        }
      });
      this.afService.loadPageSettings(this.key).subscribe((pageData) => {
        if (isUndefined(pageData.$value)) {
          this.pageSettings = pageData;
        }
      });

      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;
        if (this.componentSettings.svgType == 'svgLinedIconOptions') {
          this.iconOptions = svgLinedIconOptions;
        }
        else if (this.componentSettings.svgType == 'svgColorLinedIconOptions') {
          this.iconOptions = svgColorLinedIconOptions;
        }
        else {
          this.iconOptions = svgIconOptions;
        }
      });
    });


  }

  removeAboutSlider(index) {
    this.locationData.about.aboutUsSliderUrls.splice(index, 1);
  }

  addAboutSlider() {
    if (typeof this.locationData.about.aboutUsSliderUrls === "undefined")
      this.locationData.about.aboutUsSliderUrls = new Array<string>();
    this.locationData.about.aboutUsSliderUrls.push(null);
  }

  addAboutRow() {
    if (!this.locationData.about.rows) {
      this.locationData.about.rows = [];
    }
    this.locationData.about.rows.push(new AboutRow());
  }

  moveAboutRow(dir, index) {
    if (dir === 'up') {
      const swapIndex = index - 1;
      [this.locationData.about.rows[swapIndex], this.locationData.about.rows[index]] = [this.locationData.about.rows[index], this.locationData.about.rows[swapIndex]];
    }
    else {
      const swapIndex = index + 1;
      [this.locationData.about.rows[index], this.locationData.about.rows[swapIndex]] = [this.locationData.about.rows[swapIndex], this.locationData.about.rows[index]];
    }
  }

  removeAboutRow(index) {
    if (confirm('Are you sure?')) {
      this.locationData.about.rows.splice(index, 1);
      this.updateLocation();
    }
  }

  setFeaturesToParent() {
    this.features = this.componentSettings.features;
    this.saveFeatures();
  }

  setSmallPrimaryIconBarToParent() {
    this.smallPrimaryIconBar = this.componentSettings.smallPrimaryIconBar;
    this.saveBar();
  }




  updateShowMailingAddress(e) {
    console.log(e);
    this.locationData.showMailingAddress = e.checked;
    this.updateLocation();
  }

  onFeatureRowSelect(event) {
    this.newFeature = false;
    this.feature = event.data;
    this.displayFeatureDialog = true;
  }

  deleteFeature(featureIndex) {
    let index = -1; // -1 if not found
    for (var i = 0; i < this.locationData.featuresComponent.length; i++) {
      var element = this.locationData.featuresComponent[i];
      if (element.iconUrl === featureIndex.iconUrl && element.name === featureIndex.name && element.alt === featureIndex.alt) {
        index = i;
        break;
      }
    }
    if (confirm('Are you sure?')) {
      this.features = this.features.filter((val, i) => i != index);
      this.selectedFeature = null;
      this.displayFeatureDialog = false;
      this.saveFeatures();
    }
  }

  findFeatureIndex(): number {
    return this.features.indexOf(this.selectedFeature);
  }

  showFeatureDialogToAdd() {
    this.newFeature = true;
    this.feature = new FeatureItem();
    this.displayFeatureDialog = true;
  }

  saveFeature() {

    if (isNullOrUndefined(this.features)) {
      this.features = [];
    }

    if (this.newFeature == true) {
      this.features.push(this.feature);
    }
    /*     else {
          this.features[this.findFeatureIndex()] = this.feature;
        } */

    this.displayFeatureDialog = false;
    this.saveFeatures();
  }

  updateLocation() {
    this.afService.updateLocation(this.clientData, this.locationData).then(() => {
      this.afService.openSnackBar('Location successfully updated.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/location-component-data-settings/location-component-data-settings.component.ts